import { isEmpty } from 'lodash/fp';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetInventoriesByMobilityModuleIdQuery } from '../../../../api/queries/getInventoriesByMobilityModuleId';
import useTranslatedString from '../../../../utilities/useTranslatedString';

const useMobilityStockOptions = (moduleId: string | null | undefined) => {
    const { data, loading } = useGetInventoriesByMobilityModuleIdQuery({
        variables: { mobilityModuleId: moduleId },
        skip: isEmpty(moduleId),
    });

    const { t } = useTranslation('mobilityDetails');

    const ct = useTranslatedString();

    return useMemo(() => {
        if (loading || isEmpty(data?.inventories)) {
            return [];
        }

        const { inventories } = data;

        return inventories.flatMap(({ variant: { name }, stocks }) =>
            stocks
                .map((stock, index) => {
                    if (stock.__typename === 'MobilityStockInventory') {
                        return {
                            label: t('mobilityDetails:stockOption', { variantName: ct(name), stockNo: index + 1 }),
                            key: stock.id,
                        };
                    }

                    return null;
                })
                .filter(Boolean)
        );
    }, [data, loading, ct, t]);
};

export default useMobilityStockOptions;
